export { default } from '../../sub/terms-of-service';

